import { ReactNode } from 'react'

import { cn } from '@/libs/tw'

import { Styles, fontStyles } from './typographyUtils'

type TypographyProps = {
	style: Styles
	element?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
	children: ReactNode
	className?: string
}

export const Typography = ({ style, element, className, children }: TypographyProps) => {
	if (element === 'span')
		return <span className={cn(fontStyles[style], className)}>{children}</span>
	if (element === 'p') return <p className={cn(fontStyles[style], className)}>{children}</p>
	if (element === 'h5') return <h5 className={cn(fontStyles[style], className)}>{children}</h5>
	if (element === 'h4') return <h4 className={cn(fontStyles[style], className)}>{children}</h4>
	if (element === 'h3') return <h3 className={cn(fontStyles[style], className)}>{children}</h3>
	if (element === 'h2') return <h2 className={cn(fontStyles[style], className)}>{children}</h2>
	if (element === 'h1') return <h1 className={cn(fontStyles[style], className)}>{children}</h1>

	return <div className={fontStyles[style]}>{children}</div>
}
